// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/lp-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .footer-wrapper{
    background: #E11F1C;
}

footer{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2rem 0;
    text-align: center;
}
.join-section{
    display: flex;
    align-items: center;
    margin: 1rem 0;
}

.join-section form{
    border: 1px solid white;
    overflow: hidden;
}

.join-section .custom-input{
    width: 600px;
    background: rgba(255, 255, 255, 0.2);
    font-weight: light;
    border-radius: 0;
    padding-left: 1rem;
    margin: 0 !important;
}
.footer-social{
    width: 250px;
    text-align: center;
}
.footer-social ul{
padding: 0;
list-style: none;
display: flex;
justify-content: space-between;
margin-bottom: 0;
}
.footer-social ul a{
    color: var(--white);
    font-size: 35px;
}
footer .last-section{
    text-align: center;
    margin-top: 1rem;
}
footer .last-section p{
    color: var(--white);
    font-size: 16px;
    margin-top: 1rem;
}
footer .last-section h2{
    color: var(--white);
}

footer button{
    border-radius: 0 !important;
    transform: translateY(-1px);
}

footer button:focus{
    outline: none !important;
} */

/* Footer --------------------------------------------------------------------- */
/* footer */

.custom-footer {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom center;
    color: var(--light-gray);
}


.footer-icons svg {
    font-size: 2rem;
}

.custom-footer .rounded-input-group {
    width: 100%;
}

.footer-desc {
    line-height: 1.3em;
    font-size: 0.9rem;
    letter-spacing: 1px;
}

.custom-footer ul {
    padding-left: 0;
}

.footer-fr {
    padding-inline: 1em;
}

.custom-footer .footer-icons i,
.custom-footer li i{
    color: #fff;
}
.custom-footer li span {
    margin-left: 8px;
}

.footer-icons svg:hover {
    color: var(--primary);
}

.footer-heading {
    display: inline-block;
    color: #fff;
    box-shadow: inset 0 -1px rgb(255 255 255 / 10%);
}

/* Footer End --------------------------------------------------------------------- */`, "",{"version":3,"sources":["webpack://./src/assets/css/footer.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAkEG;;AAEH,iFAAiF;AACjF,WAAW;;AAEX;IACI,mDAAoC;IACpC,4BAA4B;IAC5B,sBAAsB;IACtB,kCAAkC;IAClC,wBAAwB;AAC5B;;;AAGA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,+CAA+C;AACnD;;AAEA,qFAAqF","sourcesContent":["/* .footer-wrapper{\n    background: #E11F1C;\n}\n\nfooter{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 2rem 0;\n    text-align: center;\n}\n.join-section{\n    display: flex;\n    align-items: center;\n    margin: 1rem 0;\n}\n\n.join-section form{\n    border: 1px solid white;\n    overflow: hidden;\n}\n\n.join-section .custom-input{\n    width: 600px;\n    background: rgba(255, 255, 255, 0.2);\n    font-weight: light;\n    border-radius: 0;\n    padding-left: 1rem;\n    margin: 0 !important;\n}\n.footer-social{\n    width: 250px;\n    text-align: center;\n}\n.footer-social ul{\npadding: 0;\nlist-style: none;\ndisplay: flex;\njustify-content: space-between;\nmargin-bottom: 0;\n}\n.footer-social ul a{\n    color: var(--white);\n    font-size: 35px;\n}\nfooter .last-section{\n    text-align: center;\n    margin-top: 1rem;\n}\nfooter .last-section p{\n    color: var(--white);\n    font-size: 16px;\n    margin-top: 1rem;\n}\nfooter .last-section h2{\n    color: var(--white);\n}\n\nfooter button{\n    border-radius: 0 !important;\n    transform: translateY(-1px);\n}\n\nfooter button:focus{\n    outline: none !important;\n} */\n\n/* Footer --------------------------------------------------------------------- */\n/* footer */\n\n.custom-footer {\n    background: url(../images/lp-bg.png);\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: bottom center;\n    color: var(--light-gray);\n}\n\n\n.footer-icons svg {\n    font-size: 2rem;\n}\n\n.custom-footer .rounded-input-group {\n    width: 100%;\n}\n\n.footer-desc {\n    line-height: 1.3em;\n    font-size: 0.9rem;\n    letter-spacing: 1px;\n}\n\n.custom-footer ul {\n    padding-left: 0;\n}\n\n.footer-fr {\n    padding-inline: 1em;\n}\n\n.custom-footer .footer-icons i,\n.custom-footer li i{\n    color: #fff;\n}\n.custom-footer li span {\n    margin-left: 8px;\n}\n\n.footer-icons svg:hover {\n    color: var(--primary);\n}\n\n.footer-heading {\n    display: inline-block;\n    color: #fff;\n    box-shadow: inset 0 -1px rgb(255 255 255 / 10%);\n}\n\n/* Footer End --------------------------------------------------------------------- */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
